import { render } from "./ReminderComplete.vue?vue&type=template&id=4945e33e"
import script from "./ReminderComplete.vue?vue&type=script&setup=true&lang=js"
export * from "./ReminderComplete.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/reminder/ReminderComplete.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4945e33e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4945e33e', __exports__)) {
    api.reload('4945e33e', __exports__)
  }
  
  module.hot.accept("./ReminderComplete.vue?vue&type=template&id=4945e33e", () => {
    api.rerender('4945e33e', render)
  })

}


export default __exports__